import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/input';
import { useToast } from '../../components/ui/ToastProvider';
import { Bell, Globe, Lock, Save, Shield } from 'lucide-react';

export const SettingsPage: React.FC = () => {
  const { showToast } = useToast();
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [smsNotifications, setSmsNotifications] = useState(false);
  const [marketingEmails, setMarketingEmails] = useState(false);
  const [twoFactor, setTwoFactor] = useState(false);

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    showToast('Settings saved successfully', 'success');
  };

  const toggleRow = (label: string, checked: boolean, onChange: (v: boolean) => void, icon: React.ReactNode) => (
    <div className="flex items-center justify-between py-3">
      <div className="flex items-center space-x-3">
        <div className="rounded-lg bg-primary/10 p-2">{icon}</div>
        <span className="text-sm font-medium">{label}</span>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className={`relative h-6 w-11 rounded-full transition-colors ${checked ? 'bg-primary' : 'bg-[rgb(var(--border))]'}`}
      >
        <span
          className={`absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white transition-transform ${
            checked ? 'translate-x-5' : ''
          }`}
        />
      </button>
    </div>
  );

  return (
    <div>
      <h1 className="text-2xl font-bold">Settings</h1>
      <p className="mt-1 text-sm text-[rgb(var(--light-secondary))]">
        Manage your preferences and account security.
      </p>

      <form onSubmit={handleSave} className="mt-6 space-y-6">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center space-x-2">
              <Globe className="h-5 w-5 text-primary" />
              <span>Notifications</span>
            </CardTitle>
          </CardHeader>
          <CardContent className="divide-y divide-[rgb(var(--border))]">
            {toggleRow('Email notifications', emailNotifications, setEmailNotifications, <Bell className="h-4 w-4 text-primary" />)}
            {toggleRow('SMS notifications', smsNotifications, setSmsNotifications, <Bell className="h-4 w-4 text-primary" />)}
            {toggleRow('Marketing emails', marketingEmails, setMarketingEmails, <Globe className="h-4 w-4 text-primary" />)}
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center space-x-2">
              <Shield className="h-5 w-5 text-primary" />
              <span>Security</span>
            </CardTitle>
          </CardHeader>
          <CardContent className="divide-y divide-[rgb(var(--border))]">
            {toggleRow('Two-factor authentication', twoFactor, setTwoFactor, <Lock className="h-4 w-4 text-primary" />)}
            <div className="py-3">
              <Input label="New password" type="password" placeholder="Leave blank to keep current" />
            </div>
          </CardContent>
        </Card>

        <div className="flex justify-end">
          <Button type="submit">
            <Save className="mr-2 h-4 w-4" />
            Save Changes
          </Button>
        </div>
      </form>
    </div>
  );
};
